<template lang="pug">
.send-message-select-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="add" @cancel="cancel")
    template(v-slot:modal-title)
      span {{ title }}
      span.font-strong-color {{ titleMessage }}

    b-card-group.send-message-select-modal-card-group(deck)
      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 種類名・グループ名
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="otherUserGroupSearchWord" type="search" placeholder="施設関係者グループの検索"
                @input="inputOtherUserGroupGroupSearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="other-user-group-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・施設関係者グループ名
                div ・施設関係者種類名
        b-list-group.select-area(flush)
          b-list-group-item(@click="selectAllGroup" href="#" :class="_allGroupSelectedClass") 全て
          template(v-for="target in targets")
            b-list-group-item(v-if="target.show" href="#" @click="selectGroup(target)" :class="getGroupSelectedClass(target.id)") {{ target.groupName }}・{{ target.name }}

      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 {{ groupName }}
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center(v-if="selectedGroupId != 0")
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="memberSearchWord" type="search"
                placeholder="施設関係者メンバーの検索" @input="inputMemberSearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="member-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・施設関係者メンバー名
        b-list-group.family-area(flush)
          b-list-group-item(v-if="0 < viewMembers.length")
            b-form-checkbox(v-model="allMember" @change="selectAllMember" :disabled="_disableAllMember")
              span 全員
          b-list-group-item(v-if="member.show" v-for="member in viewMembers" :key="member.id + '-' + member.memberId")
            b-form-checkbox(v-model="member.isTarget")
              span {{ member.memberName }}{{ getSenderType(member.senderType) }}

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { OtherUserGroupTypeGroup, OtherUserGroupTypeMember } from "@/commons/services/OtherUserGroupTypeMembers";
import { SenderType } from "@/commons/models/OtherUserGroup";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * メッセージ送信宛先選択モーダル
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class SendMessageOtherUserGroupSelectModal extends Vue {
  /** ダイアログタイトル */
  @Prop({ default: "宛先を選択してください。" })
  title!: string;
  /** タイトルメッセージ */
  @Prop({ default: undefined })
  titleMessage!: string;

  /** 施設関係者グループ検索ワード */
  otherUserGroupSearchWord: string = "";
  /** メンバー名検索ワード */
  memberSearchWord: string = "";

  /** 宛先対象リスト */
  targets: Array<OtherUserGroupTypeGroup> = [];
  /** 選択されているグループID */
  selectedGroupId: number = 0;
  /** 選択された宛先候補の利用者名 */
  groupName: string = "";
  /** 宛先候補の家族 */
  viewMembers: Array<OtherUserGroupTypeMember> = [];
  /** 家族全員が選択されてか否か */
  allMember: boolean = false;

  get _checked(): boolean {
    let checked: boolean = false;

    for (let target of this.targets) {
      for (let member of target.members) {
        if (member.isTarget == true) {
          checked = true;
          break;
        }
      }
    }

    return checked;
  }

  get _disableAllMember(): boolean {
    if (this.memberSearchWord != "") {
      return true;
    } else {
      return false;
    }
  }

  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.MAIL) {
      return "（メール）";
    } else {
      return "";
    }
  }

  get _allGroupSelectedClass(): any {
    return {
      "selected-resident": this.selectedGroupId === -1 ? true : false
    };
  }

  public getGroupSelectedClass(id: number): any {
    return {
      "selected-resident": this.selectedGroupId === id ? true : false
    };
  }

  public inputOtherUserGroupGroupSearchWord(): void {
    if (!this.otherUserGroupSearchWord) {
      for (const target of this.targets) {
        target.show = true;
      }
      return;
    }

    const words: string[] = this.$filterUtil.createSearchWord(this.otherUserGroupSearchWord);
    for (const target of this.targets) {
      target.show = false;
      for (const word of words) {
        if (-1 < target.name.indexOf(word)) {
          target.show = true;
          break;
        }
        if (target.groupName && -1 < target.groupName.indexOf(word)) {
          target.show = true;
          break;
        }
      }
      // 現在選択されている利用者グループが表示対象外の場合、利用者、家族の選択をリセットする
      if (target.id == this.selectedGroupId && target.show == false) {
        this.selectedGroupId = 0;
        this.viewMembers = [];
        this.groupName = "　";
        this.allMember = false;
      }
    }
    return;
  }

  /**
   * ### グループの全て選択イベント
   */
  public selectAllGroup(): void {
    const viewMembers = [];
    for (const group of this.targets) {
      for (const member of group.members) {
        member.show = true;
        viewMembers.push(member);
      }
    }
    this.groupName = "全て";
    this.viewMembers = viewMembers;
    this.allMember = false;

    this.selectedGroupId = -1;

    return;
  }

  /**
   * グループ選択イベント処理
   */
  public selectGroup(group: OtherUserGroupTypeGroup): void {
    this.groupName = group.name;
    this.viewMembers = group.members;
    this.allMember = this.isAllMemberChecked();

    this.selectedGroupId = group.id;

    return;
  }

  public inputMemberSearchWord(): void {
    for (const member of this.viewMembers) {
      if (!this.memberSearchWord) {
        member.show = true;
        continue;
      }

      const words: string[] = this.$filterUtil.createSearchWord(this.memberSearchWord);
      member.show = false;
      for (const word of words) {
        if (-1 < member.memberName.indexOf(word)) {
          member.show = true;
          break;
        }
      }
    }
    return;
  }

  /**
   * 宛先選択で「全員」選択イベント処理
   */
  public selectAllMember(checked: boolean): void {
    for (let member of this.viewMembers) {
      member.isTarget = checked;
    }
    this.allMember = checked;

    return;
  }

  /**
   * 宛先選択で全員がチェックされているかを調べる
   *
   * - 全家族を調べて、1人でもチェックされてないものがあればfalseを返す
   */
  public isAllMemberChecked(): boolean {
    let checked: boolean = true;

    for (let member of this.viewMembers) {
      if (member.isTarget == false) {
        checked = false;
        break;
      }
    }

    return checked;
  }

  /**
   * モーダル表示
   *
   * - 利用者は未選択の状態で表示する
   */
  public show(targets: Array<OtherUserGroupTypeGroup>): void {
    this.targets = targets;
    this.viewMembers = [];
    this.groupName = "　";
    this.allMember = false;
    this.selectedGroupId = 0;

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   *
   * - 親コンポーネントに入力情報を通知する
   */
  public add(): void {
    this.$emit("add", this.targets);

    return;
  }

  /**
   * キャンセルボタン押下イベント
   *
   * - 入力した内容を全て破棄する
   * - 親コンポーネントに通知する
   */
  public cancel(): void {
    for (let group of this.targets) {
      for (let member of group.members) {
        member.isTarget = false;
      }
    }
    this.allMember = false;

    this.$emit("cancel");

    return;
  }
}
</script>

<style lang="scss">
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.font-strong-color {
  color: $font-strong-color;
}

.send-message-select-modal-card-group {
  .select-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .family-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .selected-resident {
    background-color: $btn-selected !important;
    color: $btn-font-selected !important;
  }
  .send-message-header {
    @include bold-font(16px);
  }
  .list-group-item.resident.list-group-item-action {
    &:hover {
      background-color: $list-hover;
    }
    &:focus {
      background-color: $list-selected;
    }
  }
}
</style>
